const rmsApiProxyRetry = require('../../api/rmsApiProxyRetry');

export async function loadFloatsByDateRange(fromDate, toDate)
{
    const resourceUrl = `${rmsApiProxyRetry.getOrgContextToUrl()}/floats?fromDate=${fromDate}&toDate=${toDate}`;
    return await rmsApiProxyRetry.get(resourceUrl);
}